import { SkeletonTeamEquipmentInfoComponent } from '@/app/components/shared/skeleton/skeleton-team-equipment-info/skeleton-team-equipment-info.component';
import { TranslationService } from '@/app/services/translation.service';
import { ELanguage } from '@/app/utils';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { LineupComponent } from '../../components/equipment-lineup/equipment-lineup.component';
import { TeamEquipmentService } from '../../services';

@Component({
  selector: 'app-equipment',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzIconModule,
    LineupComponent,
    SkeletonTeamEquipmentInfoComponent,
  ],
  templateUrl: './equipment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EquipmentComponent {
  private route = inject(ActivatedRoute);
  private translatorService = inject(TranslationService);
  private teamEquipmentService = inject(TeamEquipmentService);

  equipmentStatus = computed(() => ({
    isLoading: this.teamEquipmentService.isLoadingTeamEquipment(),
    isError: this.teamEquipmentService.isErrorTeamEquipment(),
  }));

  teamEquipment = computed(() => this.teamEquipmentService.teamEquipment());

  teamId = signal<string>('');

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  currentLanguage: any = this.translatorService.getCurrentLanguage();

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const teamId = params.get('teamId');

      if (teamId) {
        this.teamId.set(teamId);
        this.teamEquipmentService.getTeamEquipment(teamId);
      }
    });
  }

  getCountryName(
    countryName: Partial<Record<ELanguage, string>>,
    name: string
  ) {
    return this.translatorService.getTraduccionName(countryName, name);
  }
}
